import React from 'react'
import cx from 'classnames'
import result from 'lodash/result'
import Icon from 'lib/components/icon'
import I18n from 'lib/components/i18n'
import { bool, string, arrayOf, object, func, element } from 'prop-types'

class Select extends React.PureComponent {
  static propTypes = {
    stretch: bool,
    disabled: bool,
    wrapperClasses: string,
    label: string,
    labelFor: string,
    labelClasses: string,
    labelVisible: bool,
    options: arrayOf(object),
    onChange: func,
    onClick: func,
    renderOption: func,
    selected: string,
    selectedText: string, // The "text", i.e. "P/B Valuation" instead of the value, i.e. "PB"
    tooltip: element
  }

  static defaultProps = {
    stretch: false,
    disabled: false,
    labelVisible: true,
    labelClasses: '',
    iconWidth: '12px',
    iconHeight: '12px',
    iconType: 'arrow-down',
    onChange: n => n,
    onClick: n => n,
    renderOption: ({ text, value, track }, i) => {
      const key = value == null ? i : value
      track = track ? track : text

      return (
        <I18n tag="option" key={key} value={value} data-track={track}>
          {text}
        </I18n>
      )
    }
  }

  getSelectedText() {
    const { selectedText, selected, options } = this.props

    const currentItem = options.find(option => option.value === selected)

    return selectedText || result(currentItem, 'text', selected)
  }

  renderAsText() {
    return (
      <span className="select">
        <I18n tag="h3" className="select__disabled-heading">
          {this.getSelectedText()}
        </I18n>
      </span>
    )
  }

  renderSelect() {
    const {
      disabled,
      labelFor,
      selected,
      onChange,
      onClick,
      renderOption,
      options
    } = this.props

    return (
      <select
        disabled={disabled}
        id={labelFor}
        value={selected}
        onChange={onChange}
        onClick={onClick}
      >
        {options.map(renderOption)}
      </select>
    )
  }

  render() {
    const {
      stretch,
      labelVisible,
      disabled,
      labelFor,
      label,
      labelClasses,
      wrapperClasses,
      iconType,
      iconWidth,
      iconHeight,
      tooltip
    } = this.props

    if (disabled) {
      return this.renderAsText()
    }

    const wrapperClassName = cx('select', wrapperClasses, {
      '-stretch': stretch
    })

    const labelClassName = cx('type-subtitle', labelClasses, {
      'screenreader-only': !labelVisible
    })

    let labelHtml = null

    if (label) {
      labelHtml = (
        <label htmlFor={labelFor} className={labelClassName}>
          {label}
        </label>
      )
    }

    return (
      <span className={wrapperClassName}>
        {labelHtml}
        {tooltip}

        <span className="select__inner">
          {this.renderSelect()}

          <span className="select__replace">
            <I18n className="select__replace__selected">
              {this.getSelectedText()}
            </I18n>

            <Icon
              type={iconType}
              className="select__replace__arrow"
              width={iconWidth}
              height={iconHeight}
            />
          </span>
        </span>
      </span>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/select/index.js